/**
 * character Data 관리 클래스
 * @category character
 * @memberof module:character
 * @param  {Object} _config={} 설정
 */
class DataStore {
    constructor(_config={}){
        this.data = {
            config: _config,
        };

        this.apiUrlList = {
            characterBasicInfo: this.data.config.apiDomain+ '/game/v1/characters/'+  this.data.config.serverType+ '/seervers/'+ this.data.config.serverId+ '/name/'+ this.data.config.characterName,
            characterAbilityInfo: this.data.config.apiDomain+ '/game/v1/characters/'+  this.data.config.serverType+ '/seervers/'+ this.data.config.serverId+ '/name/'+ this.data.config.characterName+ '/abilities',
            characterItemInfo: this.data.config.apiDomain+ '/game/v1/characters/'+  this.data.config.serverType+ '/seervers/'+ this.data.config.serverId+ '/name/'+ this.data.config.characterName+ '/equipments',
            characterSoulshieldInfo: this.data.config.apiDomain+ '/game/v1/characters/'+  this.data.config.serverType+ '/seervers/'+ this.data.config.serverId+ '/name/'+ this.data.config.characterName+ '/abilities/soulshields',
        };
    }
    /**
     * @param  {String} _key='subsub'  요청할 데이터의 키네임
     * @param  {Object} _param={} 요청시 추가할 파라미터 데이터
     * @param  {Function} _callback=()=>{} 요청 완료후 데이터 전달할 콜백 함수
     * @category testApp
     * @returns {Object} Json 데이타
     * @example
     * const appConfig = getData('sub1', {page: 1,per_page: 12}, this.render.bind(this));
     */

    getData(_key = '', _param={}, _callback = ()=>{}){
        if( this.data[_key] ){
            _callback(this.data[_key]);
        }else{
            axios.get(this.apiUrlList[_key], {
                params: _param,
                withCredentials: true
            })
            .then( (response) => {
                this.data[_key] = response.data;
                _callback(response.data);
            })
            .catch( (error) => {
                console.log(error);
            })
            .then( () => {
                // always executed
            });
        }
    }

    getCharacterListData(serverType='', _callback = ()=>{}){
        axios.get(`${this.data.config.apiDomain}/game/v1/characters`, {
            withCredentials: true
        })
        .then( (response) => {
            this.data['listInfoData'] = response.data;
            _callback(response.data);
        })
        .catch( (error) => {
            console.log(error);
        })
        .then( () => {});
    }

    getOtherCharactersListData(accountId='', _callback = ()=>{}){
        axios.get(`${this.data.config.apiDomain}/game/v1/characters/id/${accountId}`, {
            withCredentials: true
        })
            .then( (response) => {
                this.data['listInfoData'] = response.data;
                _callback(response.data);
            })
            .catch( (error) => {
                console.log(error);
            })
            .then( () => {});
    }

    getCharacterBasicData(serverType='', serverId='', characterName='', _callback = ()=>{}){
        axios.get(`${this.data.config.apiDomain}/game/v1/characters/${serverType}/servers/${serverId}/name/${characterName}`, {
            withCredentials: true
        })
        .then( (response) => {
            this.data['basicInfoData'] = response.data;
            _callback(response.data);
        })
        .catch( (error) => {
            console.log(error);
        })
        .then( () => {});
    }

    getCharacterAbilityData(serverType='', serverId='', characterName='', _callback = ()=>{}){
        let abilityPath;
        if(serverType === 'LIVE'){
            abilityPath = `${this.data.config.apiDomain}/game/v1/characters/${serverType.toLowerCase()}/servers/${serverId}/name/${characterName}/abilities`;
        }
        else{ // NEO
            abilityPath = `${this.data.config.apiDomain}/game/v1/${serverType.toLowerCase()}/servers/${serverId}/name/${characterName}/abilities`;
        }
        axios.get(abilityPath, {
            withCredentials: true
        })
        .then( (response) => {
            this.data['abilityInfoData'] = response.data;
            _callback(response.data);
        })
        .catch( (error) => {
            console.log(error);
        })
        .then( () => {});
    }

    getCharacterItemData(serverType='', serverId='', characterName='', _callback = ()=>{}){
        axios.get(`${this.data.config.apiDomain}/game/v1/characters/${serverType}/servers/${serverId}/name/${characterName}/equipments`, {
            withCredentials: true
        })
        .then( (response) => {
            this.data['itemInfoData'] = response.data;
            _callback(response.data);
        })
        .catch( (error) => {
            console.log(error);
        })
        .then( () => {});
    }

    getCharacterEffectData(serverType='', serverId='', characterName='', _callback = ()=>{}){
        axios.get(`${this.data.config.apiDomain}/game/v1/characters/${serverType}/servers/${serverId}/name/${characterName}/abilities/soulshields`, {
            withCredentials: true
        })
        .then( (response) => {
            this.data['itemInfoData'] = response.data;
            _callback(response.data);
        })
        .catch( (error) => {
            console.log(error);
        })
        .then( () => {});
    }
} // end of class
export default DataStore;
